import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Usuários/Grupos',
    path: '/gestaousuarios/usuariosgrupos',
    name: 'usuariosgrupos',
    component: () => import('@/views/gestaousuarios/usuariosgrupos/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.GESTAO_USUARIOS_GRUPOS_MENU_900100201],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Usuários/Grupos',
    path: '/gestaousuarios/usuariosgrupos/cadastro/:id?',
    parent: 'usuariosgrupos',
    name: 'usuariosgrupos_create',
    component: () => import('@/views/gestaousuarios/usuariosgrupos/InclusaoEdicao.vue'),
    meta: {
      permissions: [eTipoPermissao.GESTAO_USUARIOS_GRUPOS_MENU_900100201],
    },
    goesToMenu: false,
  },
];
